module.exports = __webpack_public_path__ + "static/media/service_online_qrcode.2e7b1cd6.png";